import { render, staticRenderFns } from "./Equipamentos.vue?vue&type=template&id=73428344&"
import script from "./Equipamentos.vue?vue&type=script&lang=js&"
export * from "./Equipamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports